import { inject, Injectable } from '@angular/core';
import { LocalStorageService } from '@core/services/local-storage.service';

const BEARER_TOKEN = 'bearer-token';
const DEPOSIT_TOKEN = 'deposit-token';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private bearerToken?: string;
  private teledepositToken?: string;
  private localStorageService = inject(LocalStorageService);

  setBearerToken(bearerToken: string): void {
    this.bearerToken = bearerToken;
    this.localStorageService.set(BEARER_TOKEN, bearerToken);
  }

  getBearerToken(): string | undefined {
    return this.bearerToken ?? this.localStorageService.get(BEARER_TOKEN);
  }

  clearBearerToken(): void {
    this.bearerToken = undefined;
    this.localStorageService.remove(BEARER_TOKEN);
  }

  setTeledepositToken(teledepositToken: string): void {
    this.teledepositToken = teledepositToken;
    this.localStorageService.set(DEPOSIT_TOKEN, teledepositToken);
  }

  getTeledepositToken(): string | undefined {
    return this.teledepositToken ?? this.localStorageService.get(DEPOSIT_TOKEN);
  }

  clearTeledepositToken(): void {
    this.teledepositToken = undefined;
    this.localStorageService.remove(DEPOSIT_TOKEN);
  }
}
